var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotification(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "notification_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 5627",
    fill: "#006e94",
    d: "M0 0h18.066v20H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 10235",
    transform: "translate(.967)",
    clipPath: "url(#notification_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 25615",
    d: "M18.056 14.941A2.317 2.317 0 0015.74 12.9a.253.253 0 01-.255-.255v-3.8a6.648 6.648 0 00-4.294-6.2 2.281 2.281 0 00.045-.443 2.203 2.203 0 00-4.406 0 2.333 2.333 0 00.043.43 6.445 6.445 0 00-4.292 6.077v3.939a.255.255 0 01-.254.255 2.314 2.314 0 00-2.316 2.038 2.259 2.259 0 002.247 2.478H6.15a2.9 2.9 0 005.767 0h3.89a2.259 2.259 0 002.249-2.478zM9.034 1.29a.914.914 0 01.912.912.8.8 0 01-.012.123 5.643 5.643 0 00-.665-.061 6.721 6.721 0 00-1.135.065.835.835 0 01-.014-.123.915.915 0 01.914-.916zm0 17.419a1.619 1.619 0 01-1.581-1.29h3.161a1.616 1.616 0 01-1.58 1.29m7.49-2.9a.959.959 0 01-.716.316H2.259a.966.966 0 01-.959-1.061 1.014 1.014 0 011.032-.87 1.548 1.548 0 001.545-1.546V8.709a5.164 5.164 0 015.157-5.161h.19a5.277 5.277 0 014.971 5.3v3.8a1.548 1.548 0 001.545 1.546 1.014 1.014 0 011.033.87.968.968 0 01-.249.749",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 25616",
    d: "M.679 7.741a.644.644 0 00.627-.506A7.555 7.555 0 013.36 3.502a.645.645 0 00-.914-.911 8.834 8.834 0 00-2.4 4.369.645.645 0 00.49.77.837.837 0 00.142.011",
    fill: "#a1ff00"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 25617",
    d: "M17.387 7.742a.655.655 0 00.139-.015.644.644 0 00.49-.769 8.847 8.847 0 00-2.4-4.371.645.645 0 10-.913.912 7.572 7.572 0 012.051 3.732.65.65 0 00.632.51",
    fill: "#a1ff00"
  }))));
}
export default SvgNotification;